/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { AbstractDataTransferObject } from 'CalltakingCoreApi';
import dayjs from 'dayjs';

export class CoreFunctions {
    public static findStaleRecords(currentRecords: AbstractDataTransferObject[], initializationTime: number): string[] {
        return currentRecords.filter((currentRecord) => dayjs(currentRecord.updatedTimestamp).isBefore(dayjs(initializationTime))).map((call) => call.uuid);
    }
}
